import React, { memo } from 'react';
import Container from './Container';

const Panel = props => <Container>{props.children}</Container>;

export default memo(Panel);
